import React from 'react'
import {useState,useContext} from 'react'
import { AuthContext } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import cookie from "js-cookie"
import { toast } from 'react-toastify';
import axios from "axios"
const Login = () => {
    const navigate = useNavigate();

    const [data, setData] = useState("")

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        try {
            e.preventDefault()
            axios
              .post(`${process.env.REACT_APP_API_URL}/signin`, data)
              .then((res) => {
                console.log(res.data);
                if (res.data.status == 200) {
                  setData(res.data.body);
                  cookie.set("user", JSON.stringify(res.data.body));
                  navigate("/home");
                  toast.success(
                    `Hlo ${res.data.body.firstname} !  Login successfully `
                  );
                } else {
                  toast.error(res.data.message);
                }
              });
        } catch (error) {
            console.log(error)
        }
    }
  return (
    <>
     {/* <!-- Page Header Start --> */}
    <div class="container-fluid page-header mb-5 p-0" style={{backgroundImage: "url(/img/carousel-bg-1.jpg)"}}>
        <div class="container-fluid page-header-inner py-5">
            <div class="container text-center">
                <h1 class="display-3 text-white mb-3 animated slideInDown">Login Now</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center text-uppercase">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Pages</a></li>
                        <li class="breadcrumb-item text-white active" aria-current="page">Contact</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    {/* <!-- Page Header End --> */}


    {/* <!-- Contact Start --> */}
    <div class="container-xxl py-5">
        <div class="container">
            <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="text-primary text-uppercase">// Login Us //</h6>
                <h1 class="mb-5">Login For More Options</h1>
            </div>
            <div class="row g-4">
                <div class="col-md-12">
                    <div class="wow fadeInUp" data-wow-delay="0.2s">
                        <form onSubmit={handleSubmit} onChange={handleChange} method="post">
                            <div class="row g-3">
                                <div class="col-md-12">
                                    <div class="form-floating">
                                        <input type="email" class="form-control" id="email" placeholder="Enter your email (e.g., amit.singh@gmail.com)"
                                        name="email"
                                       />
                                        <label for="email">Email Address</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-floating">
                                        <input type="password" class="form-control" id="password" placeholder="Enter your password"
                                        name='password'
                                       />
                                        <label for="password">Password</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-primary w-100 py-3" type="submit">Login</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Contact End --> */}

    </>
  )
}

export default Login
